/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type SbSharedItemTrackingProvider_itemSearch = {
    readonly pageType: string | null;
    readonly searchTerm: string | null;
    readonly displayUriRef: string | null;
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly serviceId: string | null;
                readonly title: string | null;
                readonly categoryPath: string | null;
                readonly browseUrl: string | null;
                readonly categoryCode: string | null;
                readonly contemporaryTrackingString: string;
                readonly seller: {
                    readonly serviceId: string | null;
                } | null;
                readonly displayPriceTracking: ReadonlyArray<{
                    readonly convertedAmountList: ReadonlyArray<{
                        readonly amount: number | null;
                        readonly currency: Currency | null;
                    } | null> | null;
                    readonly type: string | null;
                } | null> | null;
                readonly " $fragmentRefs": FragmentRefs<"freeShippingHelpers_item">;
            } | null;
        } | null;
    } | null> | null;
    readonly " $refType": "SbSharedItemTrackingProvider_itemSearch";
};
export type SbSharedItemTrackingProvider_itemSearch$data = SbSharedItemTrackingProvider_itemSearch;
export type SbSharedItemTrackingProvider_itemSearch$key = {
    readonly " $data"?: SbSharedItemTrackingProvider_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedItemTrackingProvider_itemSearch">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SbSharedItemTrackingProvider_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "searchTerm",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "categoryPath",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "browseUrl",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "categoryCode",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "contemporaryTrackingString",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "seller",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Seller",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "displayPriceTracking",
                  "name": "displayPrice",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "isTrade",
                      "variableName": "isTrade"
                    },
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "searchAndBrowse"
                    }
                  ],
                  "concreteType": "ItemDisplayPriceType",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "convertedAmountList",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ConvertedAmountList",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "currency",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "freeShippingHelpers_item",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "vertical",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "shipmentQuotes",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ShipmentQuote",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isComplimentary",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "totalAmount",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "serviceMethod",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ShipmentServiceMethod",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "region",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Region",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "regionName",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'f5e7dd87480adc50ca4db4d864b776dc';
export default node;
